<template>
  <div v-if="
  this.enableAccessAuthCreate('F1', this.getUser.pref.select.cauth) === true && licenceOK">
    <v-btn :color="ui.btnColor" flat dark @click="openDialog()">
      <v-icon left>
        add
      </v-icon>
      New
    </v-btn>
    <LicenceCard v-if="!licenceOK"
    :data="{
      title: 'Licence',
      icon: 'warning',
      colorTitle: this.ui.textSubheadingBoldWarning,
      colorIcon: this.ui.colorWarning}"
    />
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon large left :color="ui.btnColor"> add </v-icon>
            <span :class="ui.textHeadline">
              <div :class="ui.textColor">
                New Facility
              </div>
            </span>
            <v-spacer/>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text :class="ui.bkgdColor">
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheadingBold">
              {{stepInfo.title}}
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{stepInfo.msg}}
            </div>
          </v-layout>
          <v-form v-model="valid" lazy-validation>
            <v-container :class="ui.bkgdColor" v-if="this.step == 1">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.name"
                  :rules="mustBeLessThanSmall"
                  prepend-icon="title"
                  hint="facility full name"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.tag"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="fingerprint"
                  hint="facility tag"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 2">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.own"
                    :items="businessOwnershipOptions"
                    color="wplblue0"
                    prepend-icon="store"
                    hint="facility ownership"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.manage"
                    :items="facilityStructure"
                    color="wplblue0"
                    prepend-icon="account_tree"
                    hint="facility management"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.theme"
                    :items="facilityThemeOptions"
                    color="wplblue0"
                    prepend-icon="grid_view"
                    hint="facility theme"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.type"
                    :items="facilityTypeOptions"
                    color="wplblue0"
                    prepend-icon="factory"
                    hint="facility type"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 2">
              <v-layout row wrap class="ml-1 mr-1">
                <v-flex xs10 offset-xs1>
                  <v-textarea
                  :color="ui.textColor"
                  :background-color="ui.btnColor"
                  v-model="localForm.des"
                  label="facility description"
                  :disabled="false"
                  :outline="true"
                  :rules="ruleMustBeNotUndefinedANDLessThan2000"
                  hint="describe facility operations"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 3">
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> place </v-icon>
                  </v-avatar>
                  Name
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.name}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> place </v-icon>
                  </v-avatar>
                  {{localForm.name}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> fingerprint </v-icon>
                  </v-avatar>
                  Tag
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.tag}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> account_tree </v-icon>
                  </v-avatar>
                  Structure
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.manage}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> factory </v-icon>
                  </v-avatar>
                  Type
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.type}}
                </v-chip>
              </v-layout>
              <v-layout class="mt-4"/>
              <v-layout class="text-xs-left ml-2 mt-4">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> short_text </v-icon>
                  </v-avatar>
                  Facility Description
                </v-chip>
                <v-spacer/>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2 mb-2">
                <div :class="ui.textSubheading">
                  {{localForm.des}}
                </div>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                <v-chip :color="ui.bkgdColor" :text-color="ui.textColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> admin_panel_settings </v-icon>
                  </v-avatar>
                  Facility Users Data Privacy
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  As Facility Custodian you agree to follow Data Privacy Policy when processing personal data for new user who may seek access to your facility data.
              </div>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                <v-chip :color="ui.bkgdColor" :text-color="ui.textColor" :class="ui.textSubheadingBold">
                  <v-avatar>
                  <v-icon> sync_alt </v-icon>
                  </v-avatar>
                  Facility Data Sharing
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  As Facility Custodian you agree that your facility authenticated users will share, create and change facility operational, maintenance and engineering data in accordance with authority level granted by you. Please note that some business communications may be confidential and as Facility Custodian you must take reasonable steps to safeguard facility data against direct and inadvertent theft, corruption and misuse of facility data systems. Please review Terms of Use if required.
                </div>
              </v-layout>
            </v-container>
          </v-form>

        </v-card-text>

        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-xs-only"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon left> navigate_before </v-icon>
            Back
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-sm-and-up"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon> navigate_before </v-icon>
          </v-btn>
          <v-spacer/>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-xs-only">
            <v-icon left> navigate_next </v-icon>
            Next
          </v-btn>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          class="hidden-sm-and-up"
          @click="nextStep(step)" :color="ui.btnColor" flat>
            <v-icon> navigate_next </v-icon>
          </v-btn>
          <v-btn :disabled="!valid" v-if="enableSubmit"
          class="hidden-xs-only"
          @click="createNewFacility()" :color="ui.colorWarning" flat>
            <v-icon left> add </v-icon>
            Submit
          </v-btn>
          <v-btn :disabled="!valid" v-if="enableSubmit"
          class="hidden-sm-and-up"
          @click="createNewFacility()" :color="ui.colorWarning" flat>
            <v-icon> add </v-icon>
          </v-btn>
          <BtnSpin :btnSpec="btnInfo1" v-if="btnSpinChangeDetail === true"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BtnSpin from "@/frame/animation/components/BtnSpin";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import facilityOptions from "@/data/options/mixins/facilityOptions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import docLogFunctions from "@/document/log/mixins/docLogFunctions.js";
import changeDetail from "@/support/detail/mixins/changeDetail.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import relationshipsFunctions from "@/data/functions/mixins/relationshipsFunctions.js";
import businessOptions from "@/data/options/mixins/businessOptions.js";
import moment from "moment";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
import { mapGetters } from "vuex";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import LicenceCard from "@/admin/licence/components/LicenceCard";
// import getData from "@/data/cloud/firebase/mixins/getData.js";

export default {
  components: {
    BtnSpin,
    LicenceCard
  },
  // eslint-disable-next-line
  mixins: [
    adminFunctions,
    docRevsModFunctions,
    docLogFunctions,
    apptheme,
    ruleTextfield,
    facilityOptions,
    storeFunctions,
    changeDetail,
    relationshipsFunctions,
    generateID,
    generateForms,
    accessFunctions,
    businessOptions,
    licenceFunctions
  ],
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      btnSpinChangeDetail: false,
      valid: true,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        size: "flat"
      },
      indeterminateProgressBar: false,
      step: 0,
      localForm: {
        name: "",
        des: "",
        tag: "",
        manage: "Operator",
        type: "Warehouse",
        theme: "Industrial",
        own: "Private"
      },
      info: [
        {
          step: 0,
          title: "Facility Setup",
          // eslint-disable-next-line
          msg: "Facility is a physical collection of assets and units that together deliver business value. Facility management supports tactical planning of business and technical processes to ensure safe, reliable and efficient operations. The four key streams which support the facility are Operations, Maintenance, Engineering and Management.",
          icon: ""
        },
        {
          step: 1,
          title: "Critical Facility Info",
          // eslint-disable-next-line
          msg: "Facility must have a title and software tag which is also a physical tag that can be identified in the area where the facility is installed. The title and tag must be unique at the company level. The internal business process should define the preferred naming and tagging convention for the facility.",
          icon: ""
        },
        {
          step: 2,
          title: "Define Basic Info",
          // eslint-disable-next-line
          msg: "Facility basic info defines the structure of ownership, type of facility, purpose or objective of the facility and the relationship of the facility to the company. The facility may be a direct Ownership, Operations Management, Owner and Operator agreement or other operating structures.",
          error: "",
          icon: ""
        },
        {
          step: 3,
          title: "Verify and Submit",
          // eslint-disable-next-line
          msg: "Verify entered information. If you need to edit then return to previous steps. Admin will verify your request and activate the facility.",
          error: "",
          icon: ""
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getUser", "getCompany"]),
    stepInfo() {
      return this.info[this.step];
    },
    enableSubmit() {
      let logic = false;
      if (this.step === 3 && this.btnSpinChangeDetail === false) {
        logic = true;
      } else if (this.btnSpinChangeDetail === true) {
        logic = false;
      } else {
        logic = false;
      }
      return logic;
    },
    enableNextBtn() {
      let logic = false;
      if (this.step == 0) {
        logic = true;
      } else if (
        this.step == 1 &&
        this.localForm.name !== "" &&
        this.localForm.tag !== ""
      ) {
        logic = true;
      } else if (
        this.step == 2 &&
        this.localForm.itemSruct !== "" &&
        this.localForm.type !== "" &&
        this.localForm.theme !== "" &&
        this.localForm.des !== ""
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  methods: {
    nextStep(step) {
      this.step = step + 1;
    },
    previousStep(step) {
      this.step = step - 1;
    },
    openDialog() {
      this.dialog = true;
      this.step = 0;
      this.btnSpinReadResult = false;
      // download company which is used for asset
      // this.getDocumentCompanyOnly(this.getUser.pref.select.cdid);
    },
    closeDialog() {
      this.btnSpinReadResult = false;
    },
    createNewFacility() {
      this.btnSpinChangeDetail = true;
      // SET data source
      const tag = "F1";
      const did = this.generateDID("DATE", tag);
      const idg = this.generateIDG("date-gid");

      // GENERATE form
      let temp = this.generateFacilityForm(); // form is from compnew component

      // BASIC
      temp.basic.did = did;
      temp.basic.idg = idg;
      temp.basic.tag = tag;
      temp.basic.act = true; // set facility as approved
      temp.basic.title = this.localForm.name;
      temp.basic.id = this.localForm.tag;

      // CHAR
      temp.char.des = this.localForm.des;
      temp.char.own = this.localForm.own;
      temp.char.manage = this.localForm.manage;
      temp.char.type = this.localForm.type;
      temp.char.theme = this.localForm.theme;

      // STATS
      temp.stats.dcrt = moment().format();

      // REV
      temp.rev = this.generateInitialDocumentRev(tag);

      // CREATE Facility
      this.createFirebaseDocument(temp);
    }
  }
};
</script>
